var _path, _circle, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 66,
    viewBox: "0 0 40 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9014 1.28169H32.3943L23.0986 28.0423L27.3239 29.7324L36.9014 1.28169Z",
    fill: "#D59389",
    stroke: "#D59389"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 45.507,
    r: 20,
    fill: "#D59389"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8873 1H3.09857L12.3943 27.7606L16.6197 26.6338L7.8873 1Z",
    fill: "#D59389",
    stroke: "#D59389"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3239 1.28169H22.8169L14.6479 26.0704L18.5915 27.1972L27.3239 1.28169Z",
    fill: "#D59389",
    stroke: "#D59389"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7465 1H12.9578L18.3099 17.9014L21.4085 11.9859L17.7465 1Z",
    fill: "#D59389",
    stroke: "#D59389"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronze);
export default __webpack_public_path__ + "static/media/bronze.322e48426f70c366e8bd69ccca81f329.svg";
export { ForwardRef as ReactComponent };